import * as React from 'react';
import { cn } from '@/lib/utils';
import { Input } from './input';

export interface PercentageInputProps
	extends Omit<React.ComponentProps<'input'>, 'type'> {
	/** Maximum percentage value allowed (default: 100) */
	maxPercentage?: number;
}

const PercentageInput = React.forwardRef<HTMLInputElement, PercentageInputProps>(
	({ className, maxPercentage = 100, ...props }, ref) => {
		return (
			<div className="relative">
				<Input
					type="number"
					step="0.01"
					min="0"
					max={maxPercentage}
					className={cn('pr-7', className)}
					ref={ref}
					{...props}
				/>
				<span className="text-muted-foreground pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm font-medium">
					%
				</span>
			</div>
		);
	}
);

PercentageInput.displayName = 'PercentageInput';

export { PercentageInput };
